module.exports = __webpack_public_path__ + "img/m5.52ccee15.png";